import React from "react";
import Skills from "./Skills";

function Bio() {
  return (
    <div>
      {/* <h2>Bio</h2> */}
      <p id="bio">
        Hi I'm Georgia but some people like to call me Peachy. I answer to both.
        I like to make things that tickle the mind and/or your funny bone. I
        also work to develop projects that are accesible and easy to use for all
        people. In my free time I like to play games, explore NYC parks with my
        dog, and play music.
        <br />
        <br />
        As I've come to know myself throughout the years I have found that I
        work well under pressure or what I like to refer to as "grace under
        fire." I like to solve problems on LeetCocde, in web development, or
        even in my friends relationships with their upstairs neighbors. I love
        my work and I hope to share my passion with the people I spend my days
        with.
      </p>
      <br />
      <br />
    </div>
  );
}

export default Bio;
